import { useTranslation } from 'react-i18next';

import { ActionButton, ButtonGroup } from './StyledComponents';
import TextInput from '../../shared/FormStyles/TextInput.jsx';
import usePasswordForm from './hooks/usePasswordForm';
import SectionCard from '../../shared/SectionCard/SectionCard.jsx';
import styles from './account_settings.module.css';

export default function ChangePassword() {
  const {
    handleChange,
    handleSubmit,
    disabledSubmit,
    values,
    handleError,
    handleBlur,
  } = usePasswordForm();
  const { t } = useTranslation('accountSettings');

  return (
    <SectionCard
      title={t('passwordForm.title')}
      contentClassName={styles.passwordContent}
    >
      <TextInput
        value={values.password}
        onChange={handleChange}
        error={handleError('password')}
        onBlur={handleBlur}
        name="password"
        m="0 0 24px"
        label={t('passwordForm.passwordLabel')}
        type="password"
        placeholder={t('passwordForm.passwordPlaceholder')}
      />
      <TextInput
        onChange={handleChange}
        value={values.passwordConfirmation}
        error={handleError('passwordConfirmation')}
        onBlur={handleBlur}
        name="passwordConfirmation"
        label={t('passwordForm.passwordConfirmationLabel')}
        type="password"
        placeholder={t('passwordForm.passwordConfirmationPlaceholder')}
      />
      <ButtonGroup lastInputHasMessage={!!handleError('passwordConfirmation')}>
        <ActionButton
          type="submit"
          variant="containedBlue"
          onClick={handleSubmit}
          disabled={disabledSubmit}
        >
          {t('passwordForm.submit')}
        </ActionButton>
      </ButtonGroup>
    </SectionCard>
  );
}
